






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Album } from '@/store/albums/types';


@Component({})
export default class AlbumDisplay extends Vue {
    @Prop()
    album!: Album;
}
